<template>
  <v-row>
    <v-col md="6" sm="6" lg="4" v-for="card in cards" :key="card.id">
      <v-card class="elevation-0 rounded-0 live-account-card" :color="$vuetify.theme.dark ? '#162334' : '#F1F7FB'">
        <v-card-actions>
          <div class="trade-status">
            <div :class="card.iconBox">
              <v-icon>{{ card.icon }}</v-icon>
            </div>
            <div class="trade-number">
              <span>{{ card.tradeTitle }}</span>
              <span>{{ card.tradeNumber }}</span>
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="trade-dropdown">
            <v-menu rounded="0" class="trade-dropdown-menu" transition="slide-x-transition" bottom left>
              <template v-slot:activator="{ attrs, on }">
                <v-btn small tile elevation="0" class="ma-0 text-capitalize btn-account" v-bind="attrs" v-on="on" icon>
                  <v-icon :color="$vuetify.theme.dark ? '#fff' : '#162334'">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-card class="dropdown-menu-card" tile flat>
                <v-list flat outlined :color="$vuetify.theme.dark ? '#111A26' : '#F1F7FB'">
                  <v-list-item-group>
                    <v-list-item v-for="(item, i) in items" :key="i" :ripple="false" link>
                      <v-list-item-content>
                        <router-link v-text="item.text" class="text-decoration-none" router :to="item.link"></router-link>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-menu>
          </div>
        </v-card-actions>
        <v-card-actions>
          <div class="value-trades">
            <span>{{ card.tradeSubtitle }}</span>
            <span>{{ card.tradeAmount }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="value-trades">
            <span>{{ card.tradeName }}</span>
            <span>{{ card.tradeValue }}</span>
          </div>
        </v-card-actions>
        <v-card-actions>
          <div class="currency-leverage">
            <span>{{ card.currencyTitle }}</span>
            <span>{{ card.currencyName }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="currency-leverage">
            <span>{{ card.leverageTitle }}</span>
            <span>{{ card.leverageValue }}</span>
          </div>
        </v-card-actions>
        <v-card-actions>
          <div class="balance-equity">
            <span>{{ card.balanceTitle }}</span>
            <span>{{ card.balanceValue }}</span>
          </div>
          <v-spacer></v-spacer>
          <div class="balance-equity">
            <span>{{ card.equityTitle }}</span>
            <span>{{ card.equityValue }}</span>
          </div>
        </v-card-actions>
        <v-card-actions class="pb-0">
          <v-btn to="/live-trade-details" block outlined class="blink">
            <v-icon class="blink" color="#FF567F"> mdi-circle-small </v-icon>
            See Live Trades
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    items: [
      { text: "Deposit Funds", link: "/deposit" },
      { text: "Withdraw Funds", link: "/withdraw" },
      { text: "Internal Transfer", link: "/internal-transfer" },
      { text: "Change Trading Password", link: "/change-password" },
      { text: "Change Leverage", link: "/leverage" },
      { text: "Account Detail", link: "/trading-account-details" },
    ],
    cards: [
      {
        id: 1,
        iconBox: "icon-box",
        icon: "mdi-arrow-up-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
      {
        id: 2,
        iconBox: "icon-box-loss",
        icon: "mdi-arrow-down-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
      {
        id: 3,
        iconBox: "icon-box",
        icon: "mdi-arrow-up-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
      {
        id: 4,
        iconBox: "icon-box-loss",
        icon: "mdi-arrow-down-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
      {
        id: 5,
        iconBox: "icon-box",
        icon: "mdi-arrow-up-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
      {
        id: 6,
        iconBox: "icon-box-loss",
        icon: "mdi-arrow-down-thin",
        tradeTitle: "MT5 - Real",
        tradeNumber: "10025987",
        tradeSubtitle: "trade value",
        tradeAmount: "500.00",
        tradeName: "Trades",
        tradeValue: "98",
        currencyTitle: "currency",
        currencyName: "USD",
        leverageTitle: "leverage",
        leverageValue: "500:1",
        balanceTitle: "balance",
        balanceValue: "500.00",
        equityTitle: "equity",
        equityValue: "1200000",
      },
    ],
  }),
};
</script>

<style></style>
